import type { StateStore } from '@/types';
import { CreateEmployeeRequest } from '../views/AddPeopleScreen';

export interface PeopleState extends StateStore {
	currentTab: number;
	setCurrentTab: (tab: number) => void;
}
export interface ApprovedPeople {
	name: string;
	status: string;
	email: string;
	employeeId: string;
	role: string;
	group: string;
	lastInvited: Date;
}

export type EmployeeDto = {
	Id?: number// null when creating
	XpressId?: string;
	FirstName: string;
	LastName: string;
	Phone: string;
	Email: string;
	RoleIds?: number[];
	ReferenceCode?: string | null;
	GroupId?: number;
};

export enum X4bEmployeeStatus {
	ForApproval = 1,
	Invited = 2,
	Active = 3
}

export function getEmployeeStatusString(status: X4bEmployeeStatus) {
	switch (status) {
		case X4bEmployeeStatus.ForApproval: return 'For Approval';
		case X4bEmployeeStatus.Invited: return 'Invited';
		case X4bEmployeeStatus.Active: return 'Active';
		default: return 'Unknown';
	}
}

export interface X4bEmployeeListItem {
	Id: number;
	FirstName: string;
	LastName: string;
	FullName: string;
	Phone: string;
	Email: string;
	Status: X4bEmployeeStatus;
	RoleName: string;
	ReferenceCode?: string;
	GroupName?: string;
	LastInvited?: Date;
	RequestDate?: Date;
}

export interface GroupFormData {
	name: string;
	description: string;
}

export interface PeopleFormData extends CreateEmployeeRequest {

}

export interface X4bEmployeeDetailsDto extends EmployeeDto {
	SignUpDate?: Date;
	LastActive?: Date;
	LastLoginTime?: Date;
	Gender?: string;
	PreferredLodinMethod?: string;
	LastKnownCity?: string;
	InviteCode?: string;
	RoleNames?: string;
	Group_Name?: string;

	LastCompletedBooking?: Date;
	CompletedOrders?: number;
	TotalSpend?: number;
	UsualBookingTime?: string;
	AvgSpendPerTx?: number;
	AvgBookingPerWeek?: number;
	HighestTx?: number;

	TotalCompleted?: number;
	TotalCancelled?: number;

	MostUsedService?: string;
	MostPopularPartner?: string;
}
